import type { ReactElement } from 'react';

export function AllowCameraArt(): ReactElement {
  return (
    <svg
      viewBox="0 0 260 200"
      className="mx-auto h-44 w-full max-w-xs"
      role="img"
      aria-label="Mock camera permission popup with an arrow pointing to Allow"
    >
      <rect x="38" y="22" width="184" height="128" rx="22" fill="#1e2a3f" stroke="#2a3a54" strokeWidth="2" />
      <circle cx="70" cy="48" r="10" fill="#4db6a5" />
      <rect x="86" y="40" width="110" height="8" rx="4" fill="#7eb6d9" opacity="0.7" />
      <rect x="86" y="54" width="72" height="6" rx="3" fill="#7eb6d9" opacity="0.35" />
      <text
        x="130"
        y="92"
        textAnchor="middle"
        fill="#f4f1ea"
        fontSize="13"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fontWeight="600"
      >
        Allow camera?
      </text>
      <rect x="52" y="110" width="74" height="26" rx="13" fill="#0c1220" stroke="#2a3a54" />
      <text
        x="89"
        y="127"
        textAnchor="middle"
        fill="#9aa4b5"
        fontSize="10"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
      >
        Don&apos;t Allow
      </text>
      <rect x="134" y="110" width="74" height="26" rx="13" fill="#4db6a5" />
      <text
        x="171"
        y="127"
        textAnchor="middle"
        fill="#0c1220"
        fontSize="11"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fontWeight="700"
      >
        Allow
      </text>
      <path
        d="M188 164 C188 148, 178 142, 171 138"
        fill="none"
        stroke="#7ec89a"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <path d="M164 132 l10 10 -14 1 z" fill="#7ec89a" />
      <text
        x="204"
        y="178"
        fill="#7ec89a"
        fontSize="12"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fontWeight="700"
      >
        Tap Allow
      </text>
    </svg>
  );
}
